// redux/slice/bannerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";

export const fetchBannerList = createAsyncThunk(
  "banners/fetchList",
  async ({ search = "", page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `/banners?search=${search}&page=${page}&limit=${limit}`,
        authHeaders()
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
); 

export const updateBanner = createAsyncThunk(
  "banners/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
       const auth = authHeaders();
      const res = await Axios.put(
        `/banners/${id}`,
        formData,
        {
          headers: {
            ...auth.headers,  
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);



export const addBanner = createAsyncThunk(
  "banners/add",
  async (formData, { rejectWithValue }) => {
    try {
      const auth = authHeaders();

      const res = await Axios.post(
        "/banners",
        formData,
        {
          headers: {
            ...auth.headers,                 // ✅ KEEP TOKEN
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateBannerStatus = createAsyncThunk(
  "banners/updateStatus",
  async ({ id, is_active }, { rejectWithValue }) => {
    try {
      const auth = authHeaders();

      const res = await Axios.patch(
        `/banners/${id}/status`,
        { is_active }, // JSON body
        auth
      );

      return { id, is_active, res };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


const bannerSlice = createSlice({
  name: "banners",
  initialState: {
    list: [],
    total: 0,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* FETCH LIST */
      .addCase(fetchBannerList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBannerList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.data?.data || [];
        state.total = action.payload?.data?.pagination?.total || 0;
      })
      .addCase(fetchBannerList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      /* ADD BANNER */
      .addCase(addBanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addBanner.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      /* UPDATE STATUS */
    .addCase(updateBannerStatus.fulfilled, (state, action) => {
      const { id, is_active } = action.payload;

      const banner = state.list.find((b) => b.id === id);
      if (banner) {
        banner.is_active = is_active;
      }
    });

  },
});

export default bannerSlice.reducer;
